var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('yxtbiz-voice',{attrs:{"isPlay":_vm.isPlay,"text":_vm.text},nativeOn:{"click":function($event){return _vm.change.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.second))])}
var staticRenderFns = []

export { render, staticRenderFns }